/* eslint-disable @stylistic/max-statements-per-line */
import type React from 'react';

import type { Emotions } from '@vlabs/api/artemy/model';
import { useTranslation } from 'react-i18next';

interface EmotionsValueProps {
  emotions?: Emotions;
}

function EmotionsValue({
  emotions = undefined,
}: EmotionsValueProps): React.ReactNode {
  const { t } = useTranslation();
  const predominantEmotion = emotions?.predominant_emotion;
  if (!predominantEmotion) return '-';

  let value;

  // eslint-disable-next-line default-case
  switch (predominantEmotion) {
    case 'anger': { value = t('constants:гнев'); break; }
    case 'disgust': { value = t('constants:отвращение'); break; }
    case 'fear': { value = t('constants:страх'); break; }
    case 'happiness': { value = t('constants:счастье'); break; }
    case 'sadness': { value = t('constants:грусть'); break; }
    case 'surprise': { value = t('constants:удивление'); break; }
    case 'neutral': { value = t('constants:нейтральность'); break; }
  }

  return (
    <div>{value}</div>
  );
}

export { EmotionsValue };
